const WorkspaceUserActions = {
    USERS_LOADED: "workspace-users/users-loaded",
  };
  
  export default WorkspaceUserActions;
  